import Excel, { Fill } from "exceljs";

export type ProductListTheme = {
  fonts: {
    normal: Partial<Excel.Font>;
    bold: Partial<Excel.Font>;
    rootBold: Partial<Excel.Font>;
  };
  fills: {
    header: Fill;
    subHeader: Fill;
    grey: Fill;
  };
  borders: {
    thick: Excel.Border;
    thin: Excel.Border;
  };
};

export function createProductListTheme(): ProductListTheme {
  return {
    fonts: {
      bold: { name: "Arial", size: 10, bold: true },
      normal: { name: "Arial", size: 10 },
      rootBold: { name: "Arial", size: 11, bold: true },
    },
    fills: {
      header: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F8CBAD" },
      },
      subHeader: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" },
      },
      grey: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D0CECE" },
      },
    },
    borders: {
      thick: {
        style: "medium",
        color: { argb: "000000" },
      },
      thin: {
        style: "thin",
        color: { argb: "000000" },
      },
    },
  };
}
